module.exports = __webpack_public_path__ + "img/toggles.4e5bd5c1.svg";